module.exports = __webpack_public_path__ + "img/factory.ced0074c.svg";